import {
  DATALAYER_NAME,
} from '@js/src/base-functions';

document.addEventListener('DOMContentLoaded', function() {
  var ACCORDION_CONTENT_OPEN_STATE = 'msd_accordion_content-open';
  var CLOSE_LABEL = 'close';
  var OPEN_LABEL = 'open';
  var FA_UP_ARROW = 'fa-angle-up';
  var FA_DOWN_ARROW = 'fa-angle-down';

  function scrollToAccordionItem($parentElement) {
    var header = document.querySelector('.msd_ent_nav_header');
    var headerHeight;

    // fallback
    if (header === null) {
      headerHeight = 20;
    } else {
      headerHeight = header.offsetHeight;
    }

    setTimeout(function() {
      var scrollTop = $parentElement.offsetTop - headerHeight;

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      });
    }, 550);
  }

  function addChatIconBottomleft($item) {
    return function() {
      $item.classList.add('msd_chat_icon_bottom_left');
    };
  }

  function Accordion(accordionHeadClass, expandMode) {
    if (accordionHeadClass === undefined) {
      // eslint-disable-next-line no-param-reassign
      accordionHeadClass = 'msd_accordion_item_title';
    }

    if (expandMode === undefined) {
      // eslint-disable-next-line no-param-reassign
      expandMode = 'Multiple';
    }

    this.expandMode = expandMode;
    this.accordionHeadClass = accordionHeadClass;
    this.$accordionHeadItems = null;
    this.setup();
  }

  function clickHandler(accordionObj) {
    return function() {
      var buttonText = this.innerText;
      var $parentElement = this.parentElement;
      var $accordionContent = this.nextElementSibling;

      var heading = this.dataset.analytics;
      if (!$accordionContent) {
        return;
      }

      if ($accordionContent.classList.contains(ACCORDION_CONTENT_OPEN_STATE)) {
        if ($accordionContent.classList.contains('msd_faq_answer')) {
          $parentElement.style.marginBottom = 0 + 'px';
          $parentElement.classList.remove('msd_chat_icon_bottom_left');
        }

        $accordionContent.style.maxHeight = null;
        $accordionContent.classList.remove(ACCORDION_CONTENT_OPEN_STATE);
        accordionObj.dataLayerPush(CLOSE_LABEL, buttonText + '_' + heading);

        var $upArrow = this.querySelector('.' + FA_UP_ARROW);
        if ($upArrow) {
          $upArrow.classList.add(FA_DOWN_ARROW);
          $upArrow.classList.remove(FA_UP_ARROW);
        }

        return;
      }

      var $openedAccordionContent = document.querySelectorAll('.' + ACCORDION_CONTENT_OPEN_STATE);
      if ($openedAccordionContent.length > 0 && accordionObj.expandMode === 'single') {
        $openedAccordionContent.forEach(function($aElement) {
          var $pElement = $aElement.parentElement;
          if ($aElement.classList.contains('msd_faq_answer')) {
            $pElement.style.marginBottom = 0 + 'px';
            $pElement.classList.remove('msd_chat_icon_bottom_left');
          }

           
          $aElement.style.maxHeight = null;
          $aElement.classList.remove(ACCORDION_CONTENT_OPEN_STATE);

          var $aTitle = $aElement.previousElementSibling;
          var $titleArrow = $aTitle.querySelector('.' + FA_UP_ARROW);
          if ($titleArrow) {
            $titleArrow.classList.add(FA_DOWN_ARROW);
            $titleArrow.classList.remove(FA_UP_ARROW);
          }
        });
      }

      var $upDown = this.querySelector('.fa-angle-down');
      if ($upDown) {
        $upDown.classList.add('fa-angle-up');
        $upDown.classList.remove('fa-angle-down');
      }

      $accordionContent.classList.add(ACCORDION_CONTENT_OPEN_STATE);

      var actualHeight = $accordionContent.scrollHeight;
      $accordionContent.style.maxHeight = actualHeight + 'px';
      if ($accordionContent.classList.contains('msd_faq_answer')) {
        $parentElement.style.marginBottom = 16 + 'px';
        setTimeout(addChatIconBottomleft($parentElement), 500);
      }

      // init scroll top event
      scrollToAccordionItem($parentElement);

      accordionObj.dataLayerPush(OPEN_LABEL, buttonText + '_' + heading);
    };
  }

  Accordion.prototype.setup = function() {
    this.$accordionHeadItems = document.querySelectorAll('.' + this.accordionHeadClass);
    for (var i = 0; i < this.$accordionHeadItems.length; i += 1) {
      this.$accordionHeadItems[i].addEventListener('click', clickHandler(this));
    }
  };

  Accordion.prototype.dataLayerPush = function(action, label) {
    if (window[DATALAYER_NAME]) {
      window[DATALAYER_NAME].push({
        event: 'gaevent',
        eventCategory: 'accordion',
        eventAction: action,
        eventLabel: label,
      });
    }
  };

  // eslint-disable-next-line no-unused-vars
  var accordionInstance = new Accordion(undefined, 'single');

  function initialSetup() {
    var $initialOpenElement = document.querySelector('.' + ACCORDION_CONTENT_OPEN_STATE);
    if (!$initialOpenElement) {
      return;
    }

    var $paren = $initialOpenElement.parentElement;
    var actualHeight = $initialOpenElement.scrollHeight;
    $initialOpenElement.style.maxHeight = actualHeight + 'px';
    if ($initialOpenElement.classList.contains('msd_faq_answer')) {
      $paren.style.marginBottom = 16 + 'px';
      setTimeout(addChatIconBottomleft($paren), 500);
    }
  }

  initialSetup();
});
